export default __webpack_public_path__ + "static/media/solution_65.b4444f61.svg";